import { create } from 'zustand'

export interface FilialInfo {
  id: number
  empresa_id: number
  codigo: string
  razao_social: string
  nome_fantasia: string
  cnpj?: string | null
  is_matriz: boolean
  ativo: boolean
  cidade?: string | null
  uf?: string | null
}

interface FilialState {
  filialAtual: FilialInfo | null
  filiais: FilialInfo[]
  modoConsolidado: boolean  // true = ignora filial atual, mostra todas
  setFilialAtual: (f: FilialInfo | null) => void
  setFiliais: (lista: FilialInfo[]) => void
  setModoConsolidado: (b: boolean) => void
  resetFilial: () => void
}

function getInitial(): { filialAtual: FilialInfo | null; filiais: FilialInfo[]; modoConsolidado: boolean } {
  try {
    const f = localStorage.getItem('pain_filial_atual')
    const cons = localStorage.getItem('pain_modo_consolidado') === 'true'
    return { filialAtual: f ? JSON.parse(f) : null, filiais: [], modoConsolidado: cons }
  } catch { return { filialAtual: null, filiais: [], modoConsolidado: false } }
}

export const useFilial = create<FilialState>((set) => ({
  ...getInitial(),
  setFilialAtual: (f) => {
    if (f) localStorage.setItem('pain_filial_atual', JSON.stringify(f))
    else localStorage.removeItem('pain_filial_atual')
    set({ filialAtual: f })
  },
  setFiliais: (lista) => set({ filiais: lista }),
  setModoConsolidado: (b) => {
    localStorage.setItem('pain_modo_consolidado', b ? 'true' : 'false')
    set({ modoConsolidado: b })
  },
  // BUG: no logout SPA (sem reload) a filial selecionada (id/nome/consolidado)
  // ficava grudada no localStorage E no estado em memória. Ao logar em OUTRA
  // conta cujo tenant tem uma filial com o MESMO id, o Sidebar mostrava o NOME
  // antigo (filialAtual.nome_fantasia herdado) e a logo antiga (queryKey
  // ['filial-logo', id] colidia entre tenants). FIX: zerar a store de filial no
  // logout. Chamado por auth.ts logout() junto com queryClient.clear().
  resetFilial: () => {
    localStorage.removeItem('pain_filial_atual')
    localStorage.removeItem('pain_modo_consolidado')
    localStorage.removeItem('pain_filial_explicita')
    set({ filialAtual: null, filiais: [], modoConsolidado: false })
  },
}))

export function getFilialIdHeader(): string | null {
  try {
    // Modo consolidado: não envia X-Filial-Id (mostra todas)
    if (localStorage.getItem('pain_modo_consolidado') === 'true') return null
    const raw = localStorage.getItem('pain_filial_atual')
    if (!raw) return null
    const f = JSON.parse(raw) as FilialInfo
    return f?.id ? String(f.id) : null
  } catch { return null }
}
